import { createApp } from 'vue'
import { StoryblokVue, apiPlugin } from '@storyblok/vue'
import { apolloClient } from '@/utils/apolloClient'
import { amplitudeClient as amplitude } from '@/utils/amplitudeClient'
import gtmClient from './utils/gtmClient'
import { provideApolloClient } from '@vue/apollo-composable'
import { createPinia } from 'pinia'
import { sentryInit } from '@/utils/sentry'
import { createLaunchDarkly } from './utils/launchDarklyClient'
import { createHead } from '@unhead/vue/client'
import App from './App.vue'
import router from './router'

import 'normalize.css/normalize.css'
import '@outputinc/o-web-ui-core/dist/style.css'

// Initialize LaunchDarkly client (non-blocking; flags stream in after mount)
const { plugin: launchDarkly } = createLaunchDarkly()

provideApolloClient(apolloClient)

const app = createApp(App)
const pinia = createPinia()
const head = createHead()

app.use(StoryblokVue, {
  accessToken: import.meta.env.VITE_STORYBLOK_TOKEN,
  use: [apiPlugin]
})

sentryInit(app)
app.use(pinia)
app.use(amplitude)
app.use(launchDarkly) // Use the plugin returned from initialization
app.use(gtmClient)
app.use(head)
app.use(router)
app.mount('#app')
